import { Agent } from '../../providers/api/dtos';

export const isTrialAgent = (agent?: Agent) => agent && agent.inTrial;
